import { Injectable } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { GlobalService } from "app/global/global.service";
import {
  GenerationError,
  TemplateGenerationEvent,
  TemplateGenerationService,
} from "app/global/AI-generation";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoService } from "@jsverse/transloco";
import { take } from "rxjs";
import { type IGenerationService } from "../general-modals/generate-from-document-or-prompt/generate-from-document-or-prompt-modal.component";

@Injectable({ providedIn: "root" })
export class GenerateTemplateModalService implements IGenerationService {
  constructor(
    private router: Router,
    private templateGenerationService: TemplateGenerationService,
    private _translocoService: TranslocoService,
    private globalService: GlobalService,
    public modalService: NgbActiveModal,
    private fb: FormBuilder,
  ) {}

  generateFromDocument(file: File, prompt: string,
      option: { name: string; value: "template_document" | "regular" },
  ): void {
      this.generateTemplate({ file, prompt, templateType: option.value });
  }

  generateFromScratch(prompt: string,
  option: { name: string; value: "template_document" | "regular" },
  ): void {
    this.generateTemplate({ file: undefined, prompt, templateType: option.value });
  }

  handleGenerationStarts(templateId: string) {
    this.router.navigateByUrl(`/edit-template/${templateId}`);
  }

  handleGenerationError({ subject }: { subject: GenerationError }) {
    if (GenerationError.ALREADY_RUN === subject) {
      this.globalService.toastrError(
        this._translocoService.translate(
          "Already generating error (AI template generation modal) - You are already generating a template",
        ),
      );
    }
  }

  dispatchCallbackByEvent(event: TemplateGenerationEvent) {
    switch (event.status) {
      case "start":
        this.handleGenerationStarts(event.data.data.templateId);
        break;
      case "error":
        this.handleGenerationError(event.data);
        break;
    }
  }

  generateTemplate({ file, prompt, templateType }: { file?: File; prompt?: string,
      templateType: "template_document" | "regular";
  }) {
    this.templateGenerationService
      .generate(templateType,file, prompt )
      .pipe(take(1))
      .subscribe((event) => this.dispatchCallbackByEvent(event));
    this.modalService.close();
  }
}
